export default function OnboardingModal({ onDone, user }) {
  const steps = [
    { icon: "↑", color:"#E8FF47",  title: "Add images",       body: "Upload from your computer, paste a URL, or use the ORACLE Chrome extension on any website" },
    { icon: "☆", color:"#E8FF47",  title: "Bookmark refs",     body: "Hover any image and click Bookmark to pin your favourite references" },
    { icon: "◉", color:"#E8FF47",  title: "Extract colours",   body: "Hover any image and click DNA to extract a full colour palette with contrast scores" },
    { icon: "⊞", color:"#E8FF47",  title: "Build moodboards",  body: "Select images → Build Moodboard → arrange, annotate, resize canvas, export as PNG" },
    { icon: "▤", color:"#E8FF47",  title: "Collections",       body: "Create collections to group refs. Drag images onto a collection tab to add them" },
    { icon: "⌕", color:"#E8FF47",  title: "Search",            body: "Search by tag, source or keyword instantly across your whole library" },
  ];

  const extSteps = [
    "Install the ORACLE Chrome extension",
    "Hover any image on any website",
    "Click \"Save to ORACLE\" — it syncs automatically",
  ];

  return (
    <div style={{ position:"fixed", inset:0, zIndex:900, background:"rgba(0,0,0,.92)", backdropFilter:"blur(20px)", display:"flex", alignItems:"center", justifyContent:"center", padding:"16px", animation:"fade-in .3s ease" }}>
      <div style={{ width:"100%", maxWidth:"480px", maxHeight:"92vh", overflowY:"auto", background:"#0b0b1c", border:"1px solid rgba(255,255,255,.08)", borderRadius:"20px", boxShadow:"0 60px 120px rgba(0,0,0,.95)" }}>
        {/* Header */}
        <div style={{ padding:"28px 28px 20px", textAlign:"center", borderBottom:"1px solid rgba(255,255,255,.06)" }}>
          <p style={{ fontFamily:"'Bebas Neue'", fontSize:"36px", letterSpacing:".2em", color:"#E8FF47", lineHeight:1 }}>WELCOME TO ORACLE</p>
          <p style={{ fontFamily:"'DM Mono'", fontSize:"10px", color:"rgba(255,255,255,.3)", letterSpacing:".1em", marginTop:"6px" }}>Your visual reference library for design briefs.</p>
          {user?.name && <p style={{ fontFamily:"'DM Sans'", fontSize:"13px", color:"rgba(255,255,255,.45)", marginTop:"8px" }}>Signed in as {user.name}</p>}
        </div>

        {/* Feature list */}
        <div style={{ padding:"16px 20px", display:"flex", flexDirection:"column", gap:"8px" }}>
          {steps.map((s, i) => (
            <div key={i} style={{ display:"flex", alignItems:"flex-start", gap:"14px", padding:"10px 14px", borderRadius:"10px", background:"rgba(255,255,255,.03)", border:"1px solid rgba(255,255,255,.05)" }}>
              <span style={{ fontSize:"16px", color:s.color, flexShrink:0, marginTop:"1px", fontFamily:"'DM Mono'", width:"16px", textAlign:"center" }}>{s.icon}</span>
              <div>
                <p style={{ fontFamily:"'DM Mono'", fontSize:"11px", color:"rgba(232,255,71,.9)", letterSpacing:".05em", marginBottom:"3px" }}>{s.title}</p>
                <p style={{ fontFamily:"'DM Sans'", fontSize:"12px", color:"rgba(255,255,255,.38)", lineHeight:"1.55" }}>{s.body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Extension tip */}
        <div style={{ margin:"0 20px", padding:"12px 16px", borderRadius:"10px", background:"rgba(232,255,71,.04)", border:"1px solid rgba(232,255,71,.1)" }}>
          <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(232,255,71,.5)", letterSpacing:".1em", textTransform:"uppercase", marginBottom:"8px" }}>Chrome Extension</p>
          {extSteps.map((s, i) => (
            <div key={i} style={{ display:"flex", gap:"10px", alignItems:"flex-start", marginBottom:i<extSteps.length-1?"6px":0 }}>
              <span style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(232,255,71,.4)", flexShrink:0, marginTop:"2px" }}>{i+1}.</span>
              <p style={{ fontFamily:"'DM Sans'", fontSize:"12px", color:"rgba(255,255,255,.32)", lineHeight:"1.5" }}>{s}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ padding:"20px" }}>
          <button onClick={onDone} style={{ width:"100%", padding:"13px", borderRadius:"10px", border:"none", background:"#E8FF47", color:"#070710", fontFamily:"'DM Mono'", fontSize:"11px", letterSpacing:".12em", textTransform:"uppercase", cursor:"pointer", fontWeight:"700" }}>
            START BUILDING →
          </button>
        </div>
      </div>
    </div>
  );
}
